// Your bio - edit this file directly
const bio = `
I currently work in Machine Learning research. 
Previously, I studied Physics and Mathematics. 
This means I mostly chase elegant models, solve interesting problems, and stare at a whiteboard like it might answer back. 
I sometimes build things that are cool and nerdy, more often, I like to understand things deeply.
`;

export default bio.trim();
